import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'petastiElafronApostrofos';
const args = {};

export class PetastiElafronApostrofos extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
